import {
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Paper,
  Switch,
  Typography,
} from '@material-ui/core';
import clsx from 'clsx';
import React, { useContext } from 'react';

import { ctx, IStore } from 'store';

import { useStyles } from './styles';

const Channels: React.FC = () => {
  const classes = useStyles();
  const actions = useContext(ctx.actions);

  const {
    teams: { currentTeam },
  } = useContext(ctx.store);

  const handleChangeChannel = async (event: React.ChangeEvent<HTMLInputElement>) => {
    actions.misc.setLoading(true);
    if (currentTeam.teamId) {
      await ((actions.teams.channelSet({
        set: event.target.checked,
        channels: [event.target.name],
      }) as unknown) as Promise<IStore>);
    } else {
      await ((actions.tenants.groupSet({
        set: event.target.checked,
        groups: [event.target.name],
      }) as unknown) as Promise<IStore>);
    }
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Paper className={clsx(classes.paper, classes.metricBoxChart)}>
          <Grid className={classes.sides}>
            <Typography component="h2" className={classes.subtitle}>
              {currentTeam.teamId ? 'Monitored Channels' : 'Monitored Teams'}
            </Typography>
            <Typography component="h2" className={classes.text2}>
              {currentTeam.teamId
                ? `You can eject Sensla from any public or private channel listed below. You can add
                Sensla to any public channel from this list, but if you want to include Sensla to
                private channels your must do it directly from Slack.`
                : `You can add or eject Sensla from any team listed below. When you add Sensla in any team, you would be 
                monitoring all channels within the team. Also, you can eject Sensla from any team, removing the capacity of 
                read any channel inside this team`}
            </Typography>
          </Grid>
          <Grid className={classes.sides}>
            <FormControl component="fieldset" className={clsx(classes.list, classes.listChannels)}>
              <FormGroup>
                {currentTeam.teamId
                  ? currentTeam.channels.map((channel: any) => {
                      if (
                        !channel.isArchived &&
                        (!channel.isPrivate || (channel.isPrivate && channel.monitored))
                      ) {
                        return (
                          <FormControlLabel
                            key={channel.id}
                            className={`${classes.switch} no-translate`}
                            control={
                              <Switch
                                checked={channel.monitored}
                                onChange={handleChangeChannel}
                                color="primary"
                                name={channel.channelId}
                              />
                            }
                            label={channel.name}
                          />
                        );
                      }
                    })
                  : currentTeam.msGroups.map((group: any) => {
                      if (
                        !group.isArchived &&
                        (!group.isPrivate || (group.isPrivate && group.monitored))
                      ) {
                        return (
                          <FormControlLabel
                            key={group.id}
                            className={`${classes.switch} no-translate`}
                            control={
                              <Switch
                                checked={group.monitored}
                                onChange={handleChangeChannel}
                                color="primary"
                                name={group.groupId}
                              />
                            }
                            label={group.name}
                          />
                        );
                      }
                    })}
              </FormGroup>
            </FormControl>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};

export { Channels };
